// PageSnip kind normalization — shared by every surface that renders a
// process_studio_diagrams row as a leaf/card/chip (ProjectTree, the Projects
// Tree board/split panes, ContextMenu/ContextChip, SharedWithMe,
// FlowSnipAccessPage). The API's `kind` column is migrating its values:
//   'flowsnip' → 'flow'   (PageSnip Flow  — swimlane process diagram)
//   'pagesnip' → 'guide'  (PageSnip Guide — ready-made rich page)
// Read paths must accept EITHER the new or the legacy value (a server ahead
// of or behind this client), and treat a missing/unrecognized value as
// 'flow' — the same default the pre-migration callers used for legacy rows.
//
// NOT the explorer's `kind` (that page owns its own read path) and NOT
// sharingApi's `ResourceType`/chatStore's `ContextType` 'flowsnip' literal —
// those are internal API/routing identifiers, unrelated to this display kind.
export type SnipKind = 'flow' | 'guide';

export function normalizeSnipKind(raw: string | null | undefined): SnipKind {
  return raw === 'guide' || raw === 'pagesnip' ? 'guide' : 'flow';
}

export function isPageSnipGuide(raw: string | null | undefined): boolean {
  return normalizeSnipKind(raw) === 'guide';
}
